export default {
    STORYLINE_WEB: 'storylineweb',
    FACTSHEET: 'factsheet',
    SLIDER_MOBILE: 'slidermobile',
    STORY_TEXT: 'storytext',
    TABLE: 'table'
}